import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getAllMasterFilterData } from "./LoadEquipmentService";
import EquipmentMainPage from "./EquipmentMainPage";
import { withApollo } from "react-apollo";
import { useSelector } from "react-redux";
import { DEFAULT_COLUMNS, DEFAULT_FILTER, DEFAULT_PAGE_SIZE } from "../../constants";
import { loadEquipmentGridColumns } from "../schema/helpers/equipmentGridColumns";
import { CircularProgress } from "@mui/material";

const LoadEquipmentInfo = ({ client, landingPageAppSyncClient }) => {
  const [masterDataFilters, setMasterDataFilters] = useState({});
  const [myLabFilter, setMyLabFilter] = useState(null);
  const [lastFavFilter, setLastFavFilter] = useState(DEFAULT_FILTER);
  const [userFilters, setUserFilters] = useState([]);
  const [userDisplayColumn, setUserDisplayColumn] = useState([]);
  const [lastDisplayColumns, setLastDisplayColumns] = useState(DEFAULT_COLUMNS());
  const [lastPageSize, setLastPageSize] = useState(DEFAULT_PAGE_SIZE);

  const storeUser = useSelector((store) => store.user);
  useEffect(() => {
    loadFilterMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadFilterMasterData = async () => {
    // Resolve the schema-derived columns before the grid renders. Until this settles, allTableColumn
    // and the listOf… constants answer from their hand-written fallbacks.
    await loadEquipmentGridColumns().catch((error) => {
      // Loud on purpose. A failure here is not cosmetic: allTableColumn() falls back to the
      // hand-written list, so every schema-only column silently disappears from the grid and the
      // columns tool panel. The fallback keeps the page usable, but the cause must be findable.
      // eslint-disable-next-line no-console
      console.error(
        "[schema] Could not derive grid columns; falling back to the hand-written list. " +
          "Schema-only columns (Description, Equipment type, …) will be missing.",
        error
      );
    });

    const { masterFiltersList, myLabFilterMaster, userDetail, userDisplayColumnMaster } = await getAllMasterFilterData({
      client: client,
      site: storeUser?.site,
      userID: storeUser?.id
    });
    setMyLabFilter(() => myLabFilterMaster);
    setMasterDataFilters(() => masterFiltersList);
    setUserFilters(() => userDetail?.userFilters);
    setLastFavFilter(() => userDetail?.lastFavFilter);
    setUserDisplayColumn(() => userDisplayColumnMaster);
    setLastDisplayColumns(() => userDetail?.lastDisplayColumns);
  };

  if (Object.keys(masterDataFilters)?.length === 0) {
    return (
      <>
        <div
          className="loading"
          style={{
            height: 200,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <CircularProgress size={30} />
        </div>
      </>
    );
  }

  return (
    <>
      {Object.keys(masterDataFilters)?.length > 0 && (
        <>
          <EquipmentMainPage
            masterDataFilters={masterDataFilters}
            myLabFilter={myLabFilter}
            setMyLabFilter={setMyLabFilter}
            lastFavFilter={lastFavFilter}
            setLastFavFilter={setLastFavFilter}
            userFilters={userFilters}
            setUserFilters={setUserFilters}
            userDisplayColumn={userDisplayColumn}
            setUserDisplayColumn={setUserDisplayColumn}
            lastDisplayColumns={lastDisplayColumns}
            setLastDisplayColumns={setLastDisplayColumns}
            lastPageSize={lastPageSize}
            setLastPageSize={setLastPageSize}
            landingPageAppSyncClient={landingPageAppSyncClient}
          />
        </>
      )}
    </>
  );
};
export default withApollo(LoadEquipmentInfo);
